import { apiV2 } from '../lib/baseAxios';

const MEMORY_PATH = '/account/memory';

interface ErrorResponse {
  success: false;
  message: string;
}

interface SuccessResponse<T> {
  success: true;
  data: T;
}

export interface UserMemory {
  memoryText: string;
  personalizedVocabulary: string[];
  updatedAt?: Date;
}

type GetMemoryResponse = SuccessResponse<UserMemory> | ErrorResponse;

type UpdateMemoryResponse =
  | SuccessResponse<{ memoryText: string; updatedAt: Date }>
  | ErrorResponse;

export const memoryService = {
  async getMemory(): Promise<UserMemory> {
    const response = await apiV2.get<GetMemoryResponse>(MEMORY_PATH);
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },

  async updateMemory(
    memoryText: string,
  ): Promise<{ memoryText: string; updatedAt: Date }> {
    const response = await apiV2.put<UpdateMemoryResponse>(MEMORY_PATH, {
      memoryText,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data;
  },
};
